import { render } from "./pdf.vue?vue&type=template&id=7e1d9182"
import script from "./pdf.vue?vue&type=script&lang=ts"
export * from "./pdf.vue?vue&type=script&lang=ts"
script.render = render

export default script